/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';

// import * as AppPropTypes from '../../lib/PropTypes';
import { useThemeClassName } from '../../contexts/ThemeContext';
import GamesGroupItem from '../items/GamesGroup';

import styles from '../../../styles/lists/games-groups.module.scss';

const propTypes = {
    className: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({})),
    games: PropTypes.arrayOf(PropTypes.shape({})),
    participations: PropTypes.arrayOf(PropTypes.shape({})),
};

function GamesGroupsList({ className = null, items = null, games = null, participations = null }) {
    const themeClassName = useThemeClassName(styles);

    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            {(items || []).map((item) => (
                <GamesGroupItem
                    className={styles.item}
                    key={`group-${item.id}`}
                    group={item}
                    games={games}
                    participations={participations}
                />
            ))}
        </div>
    );
}

GamesGroupsList.propTypes = propTypes;

export default GamesGroupsList;
